import axios from 'axios';
import {
  getCurrentApiHost,
  API_NAMESPACE,
  API_VERSION,
} from 'config/environment';

export const triggerOtp = (token) => {
  const url = `${getCurrentApiHost()}/${API_NAMESPACE}/${API_VERSION}/users/trigger-otp?token=${token}`;

  axios.post(url);
};

export const validateOtp = async (token, otpInput) => {
  const url = `${getCurrentApiHost()}/${API_NAMESPACE}/${API_VERSION}/users/validate-otp?token=${token}`;
  const response = await axios.post(url, {
    otp: otpInput,
  });

  return response.data;
};
